import React, { useState } from "react";
import "./ProductGallery.css";

const productData = [
  {
    id: 1,
    name: "Rieter E-36	OMEGA LAP",
    image: "/assets/E-36 Omega lap spool1.jpeg",
    specs: { od: "200 mm", id: "180 mm", length: "301 mm" },
    category: "High-Performance",
    tagCode: "SYS-M80",
  },
  {
    id: 2,
    name: "LH - 20 LapSpool",
    image: "/assets/LH -10 Lap spool1.jpeg",
    specs: { od: "200mm", id: "180.2mm", length: "300.2mm" },
    category: "Standard Duty",
    tagCode: "LH-10.SYS",
  },
  {
    id: 3,
    name: "Marzoli Lw3/Cm7 UniLapSpool",
    image: "/assets/marzoliLw3.jpeg",
    specs: { od: "200mm", id: "180mm", length: "300mm" },
    category: "Custom Engineered",
    tagCode: "PR-200.180",
  },
];

// Helper function to add trademark symbol to Arklon
const addTrademarkToArklon = (text) => {
  // Replace Arklon with Arklon® (case sensitive)
  return text.replace(/Arklon/g, 'Arklon®');
};

const ProductGallery = () => {
  const [hoveredId, setHoveredId] = useState(null);

  return (
    <section className="emk-gallery-wrapper">
      <div className="emk-gallery-container">
        {/* Engineering Header Profile */}
        <header className="emk-gallery-header">
          <h1 className="emk-gallery-title">{addTrademarkToArklon("ARKLON LAPSPOOLS")}</h1>
          <p className="emk-gallery-subtitle">
            {addTrademarkToArklon("High impact grade Arklon LapSpools optimized for all comber machines as per customer specifications.")}
          </p>
        </header>

        {/* Dynamic Interactive Product Matrix Grid */}
        <div className="emk-gallery-grid">
          {productData.map((product) => {
            const isTargeted = hoveredId === product.id;
            return (
              <div
                key={product.id}
                className={`emk-prod-card ${isTargeted ? "is-focused" : ""}`}
                onMouseEnter={() => setHoveredId(product.id)}
                onMouseLeave={() => setHoveredId(null)}
              >
                {/* Structural Framing Guides */}
                <div className="emk-card-corner tl"></div>
                <div className="emk-card-corner br"></div>

                {/* Technical Product Meta-Row */}
                <div className="emk-card-top-bar">
                  <span className="emk-prod-serial">{product.tagCode}</span>
                  <div className="emk-prod-category-badge">
                    <span className="emk-badge-pip"></span>
                    {product.category}
                  </div>
                </div>

                {/* Cinematic Image Viewport Container */}
                <div className="emk-prod-viewport">
                  <div className="emk-viewport-gridline"></div>
                  <img
                    src={product.image}
                    alt={`${addTrademarkToArklon("Arklon")} ${product.name}`}
                    className="emk-prod-img"
                  />

                  {/* Digital Measurement crosshairs visible on focus state */}
                  <div className="emk-hud-crosshairs">
                    <span className="hud-line h-line"></span>
                    <span className="hud-line v-line"></span>
                  </div>
                </div>

                {/* Technical Specification and Content Card Body */}
                <div className="emk-prod-details">
                  <h3 className="emk-prod-name">{product.name}</h3>

                  {/* Redesigned Structural Data Metrics Layout Block */}
                  <div className="emk-spec-dashboard">
                    <div className="emk-spec-node">
                      <div className="emk-spec-hdr">
                        <svg
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          className="emk-spec-icon"
                        >
                          <circle cx="12" cy="12" r="10"></circle>
                          <circle cx="12" cy="12" r="6"></circle>
                        </svg>
                        <span className="emk-spec-lbl">OUTER DIA.</span>
                      </div>
                      <span className="emk-spec-val">{product.specs.od}</span>
                    </div>

                    <div className="emk-spec-node">
                      <div className="emk-spec-hdr">
                        <svg
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          className="emk-spec-icon"
                        >
                          <circle cx="12" cy="12" r="10"></circle>
                          <circle cx="12" cy="12" r="2"></circle>
                        </svg>
                        <span className="emk-spec-lbl">INNER DIA.</span>
                      </div>
                      <span className="emk-spec-val">{product.specs.id}</span>
                    </div>

                    <div className="emk-spec-node">
                      <div className="emk-spec-hdr">
                        <svg
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          className="emk-spec-icon"
                        >
                          <line x1="5" y1="9" x2="19" y2="9"></line>
                          <line x1="5" y1="15" x2="19" y2="15"></line>
                          <line x1="12" y1="5" x2="12" y2="19"></line>
                        </svg>
                        <span className="emk-spec-lbl">LENGTH</span>
                      </div>
                      <span className="emk-spec-val">
                        {product.specs.length}
                      </span>
                    </div>
                  </div>

                  {/* Micro-Interactive Dynamic Trigger Button */}
                  <a href="/products">
                    <button className="emk-quote-action-btn">

                      <span className="emk-btn-inner-layout">
                        <span>EXPLORE {addTrademarkToArklon("ARKLON")}</span>
                        <svg
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2.5"
                          className="emk-btn-arrow"
                        >
                          <line x1="5" y1="12" x2="19" y2="12"></line>
                          <polyline points="12 5 19 12 12 19"></polyline>
                        </svg>
                      </span>

                    </button>
                  </a>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ProductGallery;